import { render, staticRenderFns } from "./BanPage.vue?vue&type=template&id=85527f74&"
import script from "./BanPage.vue?vue&type=script&lang=js&"
export * from "./BanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports